import { Chip } from "@mui/material";
import { useTranslate } from "react-admin";
import CustomFilterText from "../unit/CustomFilterText";
import FilterCalendarDate from "../unit/FilterCalendarDate";
import FilterPaymentAccounts from "../unit/FilterPaymentAccounts";

const QuickFilter = ({
  label,
}: {
  label: string;
  source?: string;
  defaultValue?: any;
}) => {
  const translate = useTranslate();
  return <Chip sx={{ marginBottom: 1 }} label={translate(label)} />;
};

export const getCustomerListFilters = () => [
  <CustomFilterText label="User #" source="id" defaultValue="" />,
  <CustomFilterText
    label="Sign Up Channel"
    source="sCouponCode"
    defaultValue=""
  />,
  <CustomFilterText label="Customer Name" source="userName" defaultValue="" />,
  <CustomFilterText
    label="Customer Email"
    source="userEmail"
    defaultValue=""
  />,
  <CustomFilterText label="Mobile" source="sMobile" defaultValue="" />,
  <CustomFilterText label="State" source="state" defaultValue="" />,
  <CustomFilterText label="ZIP" source="zip" defaultValue="" />,
  // <FilterPaymentAccounts
  //   before="and"
  //   source="payment_account_number"
  //   label="Number of Payment Accounts"
  //   variant="outlined"
  // />,
  <FilterCalendarDate
    before="and"
    source="signup"
    label="Sign Up Date"
    variant="outlined"
  />,
  <FilterCalendarDate
    before="and"
    source="lastlogin"
    label="Last Login Date"
    variant="outlined"
  />,
];
